import { ChangeDetectorRef, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { VisitorsService } from './visitors.service';
import { Visitor } from './visitor';
import { ApiService } from 'app/services/api.service';
//import {Winner} from './winner';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

declare var $: any;

@Component({
  selector: 'app-visitors',
  providers: [VisitorsService],
  templateUrl: './visitors.component.html',
  styleUrls: ['./visitors.component.css'],

})
export class VisitorsComponent implements OnDestroy, OnInit {

  public winner: Visitor;
  public visitors: Visitor[]=[];
  private subscription: Subscription;
  public apiUrl: any;
  public autoScrollTimeout: any;
  public autoScrollInterval: any;
  public animationCounter: any = 1;
  public spotifyAccessToken: any;
  public isShowingWinner: boolean = false;
  public avatarStatus: string = '';
  public gridStyling: string;
  public showLoadingSpinner: boolean = true;
  // public millisTillReaload:number;

  constructor(public visitorsService: VisitorsService, private apiService: ApiService,private ref: ChangeDetectorRef, private _sanitizer: DomSanitizer) { }

  public ngOnInit() {
    
    this.apiUrl = this.apiService.getApiUrl();

    this.subscription = this.visitorsService.visitors$.subscribe((visitors: Visitor[])=>{
      this.visitors=visitors;
      this.ref.markForCheck();
      this.prepGrid(this.visitors);
    },(err)=>{
      console.log(err);
    });

    this.visitorsService.find();

    this.visitorsService.newWinnerSubject.subscribe(
      winner => {
       this.winner = winner;
      // Get spotify accesstoken
      this.apiService.get('spotifyaccesstoken').then((response:any) => {
        this.spotifyAccessToken = response.access_token;
        this.initWinnerWinnerChickenDinner(this.spotifyAccessToken, this.winner._id, this.visitors);
    }).catch((err) => {
      
    });
     }
    )


    this.purgeVisitorsWithReload();
    this.showLoadingSpinner = false;
  }
  purgeVisitorsWithReload(){
    let now = new Date();
    //time of pageReload
    let reloadTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 1, 0, 0, 0);
    let millisTillReaload = reloadTime.getTime() - now.getTime();
    
    if (millisTillReaload < 0) {
      millisTillReaload += 86400000; // it's after today, try tomorrow.
    }
setTimeout(function(){ window.location.reload()}, millisTillReaload);
  }


  prepGrid(visitors) {
    if(visitors.length <= 24) {
      this.gridStyling = 'grid-24';
    } else if(visitors.length <= 40 && visitors.length > 24) {
      this.gridStyling = 'grid-40';
    } else if(visitors.length <= 60 && visitors.length > 40) {
      this.gridStyling = 'grid-60';
    } else if(visitors.length <= 84 && visitors.length > 60) {
      this.gridStyling = 'grid-84';
    } else if(visitors.length <= 112 && visitors.length > 84) {
      this.gridStyling = 'grid-112';
    } else if(visitors.length <= 144 && visitors.length > 112) {
      this.gridStyling = 'grid-144';
    } else if(visitors.length > 144) {
      this.gridStyling = 'grid-180';
    }
  }


  initWinnerWinnerChickenDinner(spotifyAccessToken, winnerId, visitors) {
    if(this.winner.userName.ownImage == '') {
      this.avatarStatus = 'avatar-inner';
    }

    this.apiService.getRandomSpotifyTrack(spotifyAccessToken).then((response:any) => {
      var preview_url = "";
      if(response == 'invalidToken'){
      preview_url = "./assets/music/fallback.wav";
      }
      else{
      var tracks = response.tracks.items;
      preview_url = this.getRandomPreviewUrl(tracks);
      }
      var audio = $('#audio');
      audio[0].src = preview_url;
      audio[0].volume = 0;
      audio[0].play();

      audio.animate({volume: 1}, 6000).promise().then(() => {
        $('.winner-container').fireworks();
        $('.winner-container').fadeIn(5000, function() {
          $('.winner-inner').fadeIn('slow', function() {

            setTimeout(() => {
              audio.animate({volume: 0}, 6000)
            }, 12000)

            setTimeout(() => {
              for (var i=0; i < visitors.length; i++) {
                if (visitors[i]._id === winnerId) {
                  visitors[i].winnerWinterChickenDinner = true;
                } else {
                  visitors[i].winnerWinterChickenDinner = false;
                }
              }
              $('.winner-container, .winner-inner').fadeOut('slow');
            }, 18000)
          })
        });
      });

    }).catch((err) => {

    });
  }

  getRandomPreviewUrl(tracks) {
    var track = tracks[Math.floor(Math.random()*tracks.length)];
    var preview_url = track.track.preview_url;

    if(preview_url == null || typeof preview_url == 'undefined' || typeof preview_url == 'object') {
      return this.getRandomPreviewUrl(tracks);
    } else {
      return preview_url;
    }
  }

  getBackgroundImage(image) {
    return this._sanitizer.bypassSecurityTrustStyle('url(' + image + ')');
  }

  getAvatarBackgroundImage(image) {
    return this._sanitizer.bypassSecurityTrustStyle('url(' + this.apiUrl + 'avatar/' + image + '.png)');
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/visitors/visitors.component.ts